import posthog from 'posthog-js/dist/module.full'

const config = window.posthogConfig || {
  disableSessionRecording: false,
  sessionRecording: {
    maskAllInputs: false,
    maskAllText: false,
    captureNetworkRequests: true,
    recordCanvas: true
  }
};

const posthogConfig = {
  api_host: 'https://eu.i.posthog.com',
  disable_session_recording: config.disableSessionRecording,
  loaded: (posthog) => {
    posthog.register({ environment: '%AWS_ENV%' });
    
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      const status = config.disableSessionRecording 
        ? 'session recording disabled (mobile)'
        : config.sessionRecording?.recordCanvas === false
          ? 'canvas recording disabled' 
          : 'full recording enabled';
      console.log(`PostHog initialized (${status}, environment: %AWS_ENV%)`);
    }
  }
};

if (!config.disableSessionRecording && config.sessionRecording) {
  posthogConfig.session_recording = config.sessionRecording;
}

posthog.init('phc_RV5tHrUxr1iD3MPUQC1iOkaXfxopkj6K1G2UZGq8DcJ', posthogConfig);

window.posthog = posthog;

// Turbo: after each visit the new HTML is in the DOM; re-apply register + identify (Hotwire turbo:load).
// https://github.com/hotwired/turbo — fires when the page has fully loaded (initial + Drive navigations).
document.addEventListener('turbo:load', () => {
  if (typeof window.syncPosthogUserContext === 'function') {
    window.syncPosthogUserContext();
  }
});
